export const ProjectActions={
    PROJECTS_LIST:"PROJECTS_LIST",
    RESET:"RESET",
    SAVE_ANNOTATORS:"SAVE_ANNOTATORS",
    CANDIDATE_LIST:"CANDIDATE_LIST",
    SAVE_GUIDELINES:"SAVE_GUIDELINES"
}